import React, { useState, useEffect, useContext, useCallback } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import useDsosTable from "../../useDsosTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import AddDsoDialog from "./AddDsoDialog.js";
import EditDsoDialog from "./EditDsoDialog";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import CloseIcon from "@mui/icons-material/Close";
import { compte } from "variables/patrimoine.js";
import { updateAccountDso } from "services/ConfigServices";

//import "react-table/react-table.css";

// @mui/icons-material
import Edit from "@mui/icons-material/Edit";

//import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const ElectricityDso = (props) => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const { energy, parameters } = props;
  const {
    gridState,
    error,
    refetch,
    invalidate,
    handleClose,
  } = useDsosTable(
    energy,
    parameters,
    <AddDsoDialog
      energy={energy}
      parameters={parameters}
      closeModal={() => handleClose()}
      refetch={() => refetch()}
      deleteCounter={() => handleDeleteCounterChange()}
    />,
    "Nouveau distributeur",
    "Ajout d'un distributeur",
    ""
  );

  const [deleteCounter, setDeleteCounter] = useState(0);

  const [open, setOpen] = useState(false);
  const [clef, setClef] = useState();
  const [name, setName] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  let dataUsers = gridState.data;

  const handleDeleteCounterChange = (e) => {
    setDeleteCounter((prevCounter) => prevCounter + 1);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const [idSelected, setIdSelected] = useState();

  const columns = [
    {
      name: compte.energy[energy][parameters].key,
      selector: row => row.details.clef,
      maxWidth: "10rem",
      sortable: true,
    },
    {
      name: compte.energy[energy][parameters].name,
      selector: row => row.details.name,
      sortable: true, 
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">{row.details.name}</div>
        </>
      ),
    },
    realestateupdate ? 
    {
      name: "Actions",
      sortable: true,
      width: "8rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Button
              color={"success"}
              className={classes.actionButton}
              onClick={editDso(row)}
            >
              <Edit className={classes.icon} />
            </Button>
            <CustomDeleteButton
              deleteTitle={"Suppression du distributeur"}
              deleteSubTitle={
                "Êtes-vous sûr de vouloir supprimer le distributeur?"
              }
              handleSupprimer={deleteDso(row)}
            />
          </div>
        </>
      ),
    } : {},
  ];

  

  const editDso = (row) => async () => {
    let obj = dataUsers.find((o) => o.uuid === row.uuid);

    handleClickOpen();

    setIdSelected(obj.uuid);
    setClef(obj.details.clef);
    setName(obj.details.name);
  };

  const deleteDso = (row) => async () => {
    axios
      .delete(
        updateAccountDso(row.uuid, chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then(() => {
        refetch();
      })
      .catch(() => { });
  };

  const handleClefChange = (e) => {
    setClef(e.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          onSelectedRowsChange={updateState}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleEditClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleEditClose}>
            Modifier le distributeur
          </DialogTitle>
          <DialogContent dividers>
            <EditDsoDialog
              closeModal={handleEditClose}
              refetch={refetch}
              energy={energy}
              parameters={parameters}
              idSelected={idSelected}
              clef={clef}
              handleClefChange={handleClefChange}
              name={name}
              handleNameChange={handleNameChange}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default ElectricityDso;
